<script>
  import { mdiCheckCircle, mdiCloseCircle, mdiInformation } from '@mdi/js';
  import { fly } from 'svelte/transition'

  import { alert } from '../services/stores/alert'
  import Icon from '../ui/Icon.svelte'
  
  const defaultTimeOut = 2500

  const classesTypes = {
    error: 'red-text',
    info: 'blue-text',
    successful: 'green-text'
  }

  export let transition=fly;
  export let transitionOpts={y: -200};

  const dismiss = () => alert.removeAlert()
  
</script>
{#if $alert.active}

 <div id="alert" class={$alert.type} role="alert" transition:transition={transitionOpts}
             on:introstart={() => setTimeout(dismiss, $alert.timeOut ?? defaultTimeOut)}>
    {#if $alert.type}
    <span class="icon">
      {#if $alert.type === 'info'}
      <Icon path={mdiInformation} color="var(--theme-color-1)"/>
      {:else if $alert.type === 'error'}
      <Icon path={mdiCloseCircle} color="var(--bkg-color-danger)"/>
      {:else if $alert.type === 'successful'}
      <Icon path={mdiCheckCircle} color="var(--bkg-color-success)"/>
      {/if}
    </span>
    {/if}
    <span class="message">
      {$alert.message}
    </span>
    <button on:click={dismiss}>
      ✖
    </button>
 </div>
{/if}

<style>
  #alert.info {
    border-left-color: var(--theme-color-1);
  }
  
  #alert.successful {
    border-left-color: var(--bkg-color-success);
  }
  #alert.error {
    border-left-color: var(--bkg-color-danger);
  }

  #alert {
    max-width: 80%;
    position: fixed;
    z-index: 9999;
    left: 50%;
    transform: translateX(-50%);
    width: 600px;
    top: 10%;

    display: grid;
    grid-template-columns: auto 1fr auto;
    justify-items: center;
    
    font-size: 15px;
    background-color: white;
    border-radius: 5px;
    border-left: 4px solid white;

    -webkit-box-shadow: 1px 1px 8px 1px rgba(27,50,88,0.04); 
    box-shadow: 1px 1px 8px 1px rgba(27,50,88,0.04);
  }

  #alert :is(.message, button) {
    color: var(--theme-color-4);
  }

  #alert .message {
    padding: 15px 50px;
    text-transform: uppercase;
  }

  #alert button {
    border: none;
    background-color: transparent;
    padding: 15px;
    margin: 0;
    right: 0;
  }

  #alert .icon {
    padding: 15px;
    display: flex;
  }

</style>